import { createFileRoute } from "@tanstack/react-router";

import UpdateProductForm from "@/components/organisms/products/UpdateProductForm";

const UpdateProduct = () => {
  const { productId } = Route.useParams();

  return <UpdateProductForm productId={productId} />;
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/product/$productId/update")({
  component: UpdateProduct,
});
